import { FC, useEffect } from 'react';

import cx from 'classnames';
import { DashboardContextActionTypes } from '../../lib/contexts/dashboard/DashboardContext.types';
import DashboardDesktop from './DashboardDesktop';
import DashboardMobile from './DashboardMobile';
import DashboardTablet from './DashboardTablet';
import { GET_FARM_PROVINCE } from '../../lib/graphql/FarmInformation.gql';
import { GET_USER_REWARDS_ACCESS_QUERY } from '../../lib/graphql/UserInformation.gql';
import { Language } from '../../lib/constants/i18n';
import { Province } from '../../__generated__/graphql';
import styles from './Dashboard.module.scss';
import { useBreakpoint } from '../../lib/hooks';
import useDashboardContext from '../../lib/contexts/dashboard/useDashboardContext';
import { usePageTitle } from '../../lib/hooks/usePageTitle';
import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';

const Dashboard: FC = () => {
  usePageTitle();
  const {
    i18n: { language },
  } = useTranslation();
  const { data: userData } = useQuery(GET_USER_REWARDS_ACCESS_QUERY);
  const { data: farmData, loading: farmDataLoading } = useQuery(GET_FARM_PROVINCE);
  const { isXs, isLg } = useBreakpoint();
  const [, dispatchDashboard] = useDashboardContext();

  /**
   * Enables Summer Sizzler promotional banner only for farms based on
   * Alberta, Saskatchewan and Manitoba, also is only visible in english
   */
  useEffect(() => {
    if (!farmDataLoading && farmData) {
      if (
        (farmData.farm.farmInfo.address?.province === Province.Ab ||
          farmData.farm.farmInfo.address?.province === Province.Mb ||
          farmData.farm.farmInfo.address?.province === Province.Sk) &&
        language === Language.En
      ) {
        dispatchDashboard({
          type: DashboardContextActionTypes.UpdateDisplaySummerSizzlerBanner,
          payload: true,
        });
      } else {
        dispatchDashboard({
          type: DashboardContextActionTypes.UpdateDisplaySummerSizzlerBanner,
          payload: false,
        });
      }
    }
  }, [farmData, farmDataLoading, language]);

  const renderDashboardView = () => {
    if (isXs) {
      return <DashboardMobile hasAccess={userData?.user.hasAccess} />;
    } else if (isLg) {
      return <DashboardTablet hasAccess={userData?.user.hasAccess} />;
    }
    return <DashboardDesktop hasAccess={userData?.user.hasAccess} />;
  };

  return <div className={cx(styles['dashboard'])}>{renderDashboardView()}</div>;
};

Dashboard.displayName = 'Dashboard';

export default Dashboard;
